<script>
  let { error } = $props();
</script>

<div class="border rounded border-danger border-3 p-3 my-2">
  <p class="mb-0">{error}</p>
</div>
